var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.75,
    height: 14.063,
    viewBox: "0 0 18.75 14.063",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M18.311.469a.451.451,0,0,1,.469.469v.469a.451.451,0,0,1-.469.469H.5a.451.451,0,0,1-.469-.469V.938A.451.451,0,0,1,.5.469ZM2.227-2.344.381-4.424a1.4,1.4,0,0,1-.352-.937,1.358,1.358,0,0,1,.029-.264,1.59,1.59,0,0,1,.264-.557,1.153,1.153,0,0,1,.469-.41l.469-.264A1.421,1.421,0,0,1,1.9-7a1.421,1.421,0,0,1,.645.146l1.611.85h.029L6.152-7.061,3.105-9.053a1.467,1.467,0,0,1-.454-.513,1.335,1.335,0,0,1-.19-.659,1.391,1.391,0,0,1,.22-.718,1.235,1.235,0,0,1,.542-.513l1.055-.557a1.229,1.229,0,0,1,.645-.176,1.407,1.407,0,0,1,.5.088l5.889,2.314h.029l2.607-1.377a4.991,4.991,0,0,1,2.373-.645,1.49,1.49,0,0,1,.293.029A2.093,2.093,0,0,1,18.6-10.723a2.462,2.462,0,0,1-.381,2.373,5.556,5.556,0,0,1-2.08,1.875l-8.2,4.336A2.26,2.26,0,0,1,6.914-1.9l-3.633.029A1.338,1.338,0,0,1,2.227-2.344ZM1.9-5.6l-.469.234,1.846,2.08,3.633-.029A.84.84,0,0,0,7.295-3.4l8.2-4.336a3.875,3.875,0,0,0,1.523-1.377q.469-.732.322-1-.088-.234-.85-.264a.553.553,0,0,0-.176-.029,3.776,3.776,0,0,0-1.729.469l-3.164,1.7-6.5-2.549-1.055.557L8.936-6.914,4.189-4.424Z",
    transform: "translate(-0.029 12.188)",
    fill: "#7f7f7f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookings);
export default __webpack_public_path__ + "static/media/bookings.ed75293732b52ce854dbf84e5c7c7ede.svg";
export { ForwardRef as ReactComponent };